import Vue from "vue";
import Vuex from "vuex";

// vuex是插件，使用插件
Vue.use(Vuex)


// 暴露出去以便使用
export default {
    state: {
        // 表单数据
        form_data: {},
        version: null,
    },
    actions: {
        // 异步操作
    },
    mutations: {
        // 同步代码
        setFormData (state, from) {
            // 存储表单数据
            state.form_data = { ...from }
        },
        setVersion (state, version) {
            state.version = version
        },
    },
}